import React from 'react';
import style from "./index.module.css";
import {fileBaseUrl} from "../../utils";

const NoticeArticle = ({subpath, articleId}: { subpath: string, articleId: string }) => {
    // const docUrl = `https://lsc.huzhouliangshanshengtai.com/file/liangshan_article_${articleId}.doc`
    const comFile = fileBaseUrl();
    const docUrl = `${comFile}liangshan_article_${articleId}.doc`

    return (
        <div>
            <div className={style.articleTitle}>
                {subpath === 'c1' ? '通知公告'
                    : subpath === 'c2' ? '行业动态'
                        : subpath === 'c3' ? '政策法规'
                            : ""}
            </div>

            <div className={style.content}>
                <iframe style={{width: "98%", height: "800px"}} title={"docViewer"}
                        src={"https://view.officeapps.live.com/op/view.aspx?src=" + docUrl + "&timestamp=" + Date.now()}/>
            </div>
        </div>
    );
};

export default NoticeArticle;